import React, { createContext, useCallback, useContext, useState } from 'react';

const NavActionsContext = createContext({
  actions: [],
  register: () => () => {},
  navRightActions: [],
  registerNavRight: () => () => {},
});

export function NavActionsProvider({ children }) {
  const [actions, setActions] = useState([]);
  const [navRightActions, setNavRightActions] = useState([]);

  const register = useCallback((id, label, onClick) => {
    setActions(prev => [...prev.filter(a => a.id !== id), { id, label, onClick }]);
    return () => setActions(prev => prev.filter(a => a.id !== id));
  }, []);

  const registerNavRight = useCallback((id, title, onClick, renderIcon) => {
    setNavRightActions(prev => [...prev.filter(a => a.id !== id), { id, title, onClick, renderIcon }]);
    return () => setNavRightActions(prev => prev.filter(a => a.id !== id));
  }, []);

  return (
    <NavActionsContext.Provider value={{ actions, register, navRightActions, registerNavRight }}>
      {children}
    </NavActionsContext.Provider>
  );
}

export const useNavActions = () => useContext(NavActionsContext);
